// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"80e2f5b2","801":"7db40b63"}[chunkId] + ".chunk.js";
};